import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, FadeUp } from "@/components/site/Reveal";
import { JOIN } from "@/data/content";

const Row = ({ j, i }) => (
  <FadeUp delay={i * 0.08}>
    <Link to={`/join/${j.type}`} data-testid={`join-row-${j.type}`}
      className="group relative grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-center py-8 md:py-10 border-b border-white/15">
      <span className="md:col-span-1 font-mono-x text-sm text-[#ff8fbf]">0{i + 1}</span>
      <h3 className="md:col-span-5 font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl group-hover:translate-x-3 transition-transform duration-500">
        {j.short}
      </h3>
      <p className="md:col-span-4 text-white/75 leading-relaxed">{j.blurb}</p>
      <div className="md:col-span-2 flex md:justify-end">
        <span className="h-14 w-14 rounded-full border border-white/30 grid place-items-center group-hover:bg-brand-gradient group-hover:border-transparent group-hover:rotate-45 transition-[background-color,transform,border-color] duration-500">
          <ArrowUpRight className="w-6 h-6" />
        </span>
      </div>
      <img src={j.img} alt="" aria-hidden
        className="hidden lg:block pointer-events-none absolute right-40 top-1/2 -translate-y-1/2 w-48 h-32 object-cover rounded-2xl opacity-0 scale-90 rotate-[-4deg] group-hover:opacity-100 group-hover:scale-100 group-hover:rotate-0 transition-[opacity,transform] duration-500" />
    </Link>
  </FadeUp>
);

export default function JoinSection() {
  return (
    <section id="join" className="relative py-24 sm:py-32 bg-[#14083E] text-white overflow-hidden grain" data-testid="join-section">
      <div aria-hidden className="absolute -top-32 left-1/2 h-[480px] w-[480px] rounded-full bg-[#E5157A]/25 blur-[140px]" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-10">
          <FadeUp className="lg:col-span-8">
            <Eyebrow dark>Join us</Eyebrow>
            <h2 className="mt-5 font-display font-extrabold tracking-[-0.03em] leading-[0.98] text-4xl sm:text-5xl lg:text-6xl">
              Expand our network, <span className="text-brand-gradient">expand your reach.</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.1} className="lg:col-span-4">
            <p className="text-white/75 leading-relaxed">IMG Health grows through people and organisations who share our standards. Pick the track that fits you and apply in minutes.</p>
          </FadeUp>
        </div>
        <div className="border-t border-white/15">
          {JOIN.map((j, i) => <Row key={j.type} j={j} i={i} />)}
        </div>
      </div>
    </section>
  );
}
